module.exports = __webpack_public_path__ + "img/icon5.e28d761d.svg";